import type { OrganizationRiskSetting, Risk, RiskType, SustainabilityArea } from '@app/src/types/resourceExplorer'
import { createContext, useContext } from 'react'

export type RiskSettingsContextProps = {
  riskSettings: OrganizationRiskSetting[]
  activeRiskSettings: RiskType[]
  activeCountryRiskSettings: RiskType[]
  activeIndustryRiskSettings: RiskType[]
  isLoadingRiskSettings: boolean
  isErrorRiskSettings: boolean
  getCountryRisksForSustainabilityArea: (
    countryRisks: Risk[] | undefined,
    sustainabilityArea: SustainabilityArea,
  ) => Risk[]
}

const RiskSettingsContext = createContext<RiskSettingsContextProps>({
  riskSettings: [],
  activeRiskSettings: [],
  activeCountryRiskSettings: [],
  activeIndustryRiskSettings: [],
  isLoadingRiskSettings: true,
  isErrorRiskSettings: false,
  getCountryRisksForSustainabilityArea: () => [],
})

export const useRiskSettings = (): RiskSettingsContextProps => {
  return useContext(RiskSettingsContext)
}

export default RiskSettingsContext
